import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	boxContainer: {
		display       : "flex",
		flexDirection : props?.direction,
		marginTop     : "2rem",
		gap           : props?.customClass?.gap,
		width         : props?.direction === "column" ? "25%" : "100%"
	},
	ellipse: {
		height          : "4px",
		width           : "4px",
		borderRadius    : "50%",
		backgroundColor : theme.other.colors.text.secondary,
		margin          : "0rem 0.7rem"

	},
	flex: {
		display: "flex"
	},
	imgContainer: {
		width    : props?.direction === "column" ? "100%" : props?.customClass.imgContainerWidth,
		minWidth : "100px",
		position : "relative"
	},
	isLiveContainer: {
		position       : "absolute",
		left           : "10px",
		top            : "10px",
		zIndex         : "1",
		background     : "linear-gradient(to right, #ff0956, #ff5310)",
		borderRadius   : "5px",
		display        : "flex",
		justifyContent : "center",
		width          : "4rem"
	},
	isLiveText: {
		color      : "#fff",
		fontWeight : "500",
		fontSize   : "1.2rem"
	},
	thumbnail: {
		borderRadius    : "10px",
		aspectRatio     : "16/9",
		objectFit       : "contain",
		backgroundColor : "#000",
		border          : `0.5px solid ${ theme.other.paletteNew.darkModeWhite20 }`
	},
	contentContainer: {
		display        : "flex",
		justifyContent : "space-between",
		width          : props?.direction === "column" ? props?.customClass?.columnContentContainerWidth : props?.customClass?.rowContentContainerWidth
	},
	contentWrapper: {
		display       : "flex",
		flexDirection : "column",
		width         : "100%"
	},
	streamTitle: {
		display         : "-webkit-box",
		cursor          : "pointer",
		flexWrap        : "wrap",
		fontSize        : props?.customClass?.title,
		fontWeight      : "500",
		overflow        : "hidden",
		textOverflow    : "ellipsis",
		WebkitLineClamp : "2",
		WebkitBoxOrient : "vertical",
		textDecoration  : "none",

		"&:hover": {
			textDecoration: "underline"
		},

		[rooterMediaQuery.tablet]: {
			WebkitLineClamp: "1"
		}
	},
	name: {
		fontSize        : props?.customClass?.detailsFont,
		display         : "-webkit-box",
		WebkitLineClamp : 1,
		overflow        : "hidden",
		WebkitBoxOrient : "vertical",
		textOverflow    : "ellipsis",

		"&:hover": {
			textDecoration: "underline"
		}
	},
	image: {
		width        : props?.customClass?.image,
		height       : props?.customClass?.image,
		borderRadius : "50%",
		marginRight  : "5px"
	},
	streamInfo: {
		marginTop  : "0.5rem",
		fontSize   : props?.customClass?.detailsFont,
		color      : theme.other.colors.text.secondary,
		display    : "flex",
		alignItems : "center"
	},
	dotIcon: {
		transform : "scale(0.7)",
		width     : "40px",
		height    : "40px",
		cursor    : "pointer"
	},
	svgIconFollow: {
		transform : "scale(0.8)",
		cursor    : "pointer"
	},
	verifiedSvg: {
		width      : "14px",
		height     : "14px",
		marginLeft : "5px"
	},
	nameAndImageContainer: {
		marginTop  : "0.5rem",
		display    : "flex",
		alignItems : "center",
		cursor     : "pointer"

	},
	timeStampOverflow: {
		textOverflow    : "ellipsis",
		WebkitLineClamp : 1,
		overflow        : "hidden",
		display         : "-webkit-box",
		WebkitBoxOrient : "vertical"
	}
} ) );
